/* global angular */
( function () {
	'use strict';

	function ObsPdfExportModalCtrl ( title, fileTypes, fileNameIndex, filename, generatePdf, $modalInstance, exportService ) {
		var self = this;

		function closeModal () {
			$modalInstance.close();
		}

		function exportPdf () {
			generatePdf( exportService.formatShowOptions( self.showItemsList ), self.fileName );
		}

		function activate () {
			self.showItemsList = exportService.exportOptions();
			self.fileTypes     = fileTypes;
			self.type          = fileTypes[ 0 ];
			self.title         = title;
			self.fileName      = filename;
			self.closeModal    = closeModal;
			self.exportPdf     = exportPdf;
		}

		activate();
	}

	ObsPdfExportModalCtrl.$inject = [ 'title', 'fileTypes', 'fileNameIndex', 'filename', 'generatePdf', '$modalInstance', 'exportService' ];

	angular
		.module( 'app.observations' )
		.controller( 'ObsPdfExportModalCtrl', ObsPdfExportModalCtrl );
} )();
